import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import works from '@/pages/works'
import news from '@/pages/news'
import laws from '@/pages/laws'
import courses from '@/pages/courses'
import helps from '@/pages/helps'
import aboutus from '@/pages/aboutus'
import personal from '@/pages/personal'
// import login from '@/pages/login'
import findpw from '@/pages/findpw'
import register from '@/pages/register'
import courseBuyDetails from '@/pages/courseBuyDetails'
import packagebuy from '@/pages/packagebuy'
import video from '@/pages/video'
import gongxuke from '@/pages/gongxuke'
import checkzhengshu from '@/pages/checkzhengshu'

import newsDetails from '@/commons/newsDetails'
import courseDetails from '@/commons/courseDetails'
import personcourseDetails from '@/commons/personcourseDetails'


import basicinfo from '@/components/basicinfo'
import pxcourses from '@/components/pxcourses'
import courselist from '@/components/courselist'
import jointest from '@/components/jointest'
import testrecord from '@/components/testrecord'
import filerecord from '@/components/filerecord'
import orderdetails from '../components/orderdetails'
import allorders from '@/components/allorders'
import interactive from '@/components/interactive'

import commonHeader from '@/commons/header'
import commonFooter from '@/commons/footer'
import couse from '../pages/couse'
import tankuang from '../pages/tankuang'
import my from '../pages/my'
import textpaper from '../pages/textpaper'
import packagedetail from '../pages/packagedetail'
import personalpackage from '../pages/personalpackage'
import kaoshi from '../pages/kaoshi'
import submit from '../pages/submit'
import ts from '../pages/ts'
Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/index'
        },

        {
            path: '/index',
            name: 'index',
            components: {
                comheader: commonHeader,
                default: index,
                comfooter: commonFooter,
            }
        },
        {
            path: '/video',
            name: 'video',
            components: {
                default: video,
            }
        },
        // {
        //     path: '/login',
        //     name: 'login',
        //     components: {
        //         default: login,
        //     }
        // },
        {
            path: '/findpw',
            name: 'findpw',
            components: {
                comheader: commonHeader,
                default: findpw,
                comfooter: commonFooter,
            }
        },
        {
            path: '/gongxuke',
            name: 'gongxuke',
            components: {
                default: gongxuke,
                comfooter: commonFooter,
            }
        },
        {
            path: '/register',
            name: 'register',
            components: {
                comheader: commonHeader,
                default: register,
                comfooter: commonFooter,
            }
        },
        {
            path: '/works',
            name: 'works',
            components: {
                comheader: commonHeader,
                default: works,
                comfooter: commonFooter,
            }
        },
        {
            path: '/news',
            name: 'news',
            components: {
                comheader: commonHeader,
                default: news,
                comfooter: commonFooter,
            }
        },
        {
            path: '/laws',
            name: 'laws',
            components: {
                comheader: commonHeader,
                default: laws,
                comfooter: commonFooter,
            }
        },
        {
            path: '/courses',
            name: 'courses',
            components: {
                comheader: commonHeader,
                default: courses,
                comfooter: commonFooter,
            }
        },
        {
            path: '/helps',
            name: 'helps',
            components: {
                comheader: commonHeader,
                default: helps,
                comfooter: commonFooter,
            }
        },
        {
            path: '/aboutus',
            name: 'aboutus',
            components: {
                comheader: commonHeader,
                default: aboutus,
                comfooter: commonFooter,
            }
        },
        {
            path: '/checkzhengshu',
            name: 'checkzhengshu',
            components: {
                comheader: commonHeader,
                default: checkzhengshu,
                comfooter: commonFooter,
            }
        },
        {
            path: '/courseBuyDetails',
            name: 'courseBuyDetails',
            components: {
                default: courseBuyDetails,
            }
        },
        {
            path: '/packagebuy',
            name: 'packagebuy',
            components: {
                default: packagebuy,
            }
        },
        {
            path: '/newsDetails/:newsId',
            name: 'newsDetails',
            components: {
                comheader: commonHeader,
                default: newsDetails,
                comfooter: commonFooter,
            }
        },
        {
            path: '/courseDetails/:courseId',
            name: 'courseDetails',
            components: {
                comheader: commonHeader,
                default: courseDetails,
                comfooter: commonFooter,
            }
        },
        {
            path: '/personcourseDetails/:courseId',
            name: 'personcourseDetails',
            components: {
                default: personcourseDetails,
            }
        },
        {
            path: '/personal',
            components: {
                comheader: commonHeader,
                default: personal,
                comfooter: commonFooter,
            },
            redirect: '/personal/basicinfo',
            children: [
                { path: 'pxcourses', name: 'pxcourses', component: pxcourses },
                { path: 'basicinfo', name: 'basicinfo', component: basicinfo },
                { path: 'courselist', name: 'courselist', component: courselist },
                { path: 'jointest', name: 'jointest', component: jointest },
                { path: 'testrecord', name: 'testrecord', component: testrecord },
                { path: 'filerecord', name: 'filerecord', component: filerecord },
                { path: 'allorders', name: 'allorders', component: allorders },
                { path: 'interactive', name: 'interactive', component: interactive },
            ]
        }, {
            path: '/my',
            name: 'my',
            component: my
        }, {
            path: '/couse',
            name: 'couse',
            component: couse
        }, {
            path: '/textpaper',
            name: 'textpaper',
            component: textpaper
        }, {
            path: '/packagedetail',
            name: 'packagedetail',
            components: {
                comheader: commonHeader,
                default: packagedetail,
                comfooter: commonFooter,
            }
        }, {
            path: '/personalpackage',
            name: 'personalpackage',
            components: {
                default: personalpackage,
            }
        }, {
            path: '/kaoshi',
            name: 'kaoshi',
            component: kaoshi
        }, {
            path: '/tankuang',
            name: 'tankuang',
            component: tankuang
        }, {
            path: '/submit',
            name: 'submit',
            component: submit
        }, { path: '/orderdetails', name: 'orderdetails', component: orderdetails }, {
            path: '/ts',
            name: 'ts',
            component: ts
        }

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js